export default
{
    TYPE_LOGIN : "login",
    Type_LOGOUT : "logout",
}